import ThemeTab from './ThemeTab'

export default [ThemeTab]